export default __webpack_public_path__ + "static/media/rubik-v12-latin-600.6fdf0712.ttf";